import { Action } from 'redux';

export const AUTH_RESET = 'auth/reset';

export const AUTH_SET_TOKEN = 'auth/set_token';

interface AuthResetAction extends Action<typeof AUTH_RESET> {}

interface AuthSetTokenAction extends Action<typeof AUTH_SET_TOKEN> {
    payload: {
        token: string;
    };
}

export type AuthAction = AuthResetAction | AuthSetTokenAction;
